import { call, put } from "redux-saga/effects";
import {
    getModuleByIdLookUp, removeModuleById, getAllFormModuleTableData, getAllFormModuleData, getForms, createModule, getFormModuleList, getModuleById, updateModuleById, getManageModules,
    createManageModule,
    updateManageModule,
    getAllFormModuleList
} from "../../../../Services/apiService";
import {
    getModuleByIdLookUpSuccess, getModuleByIdLookUpFailure, removeModuleByIdSuccess, removeModuleByIdFailure, getAllFormModuleSuccess, getAllFormModuleFailure, updateModuleByIdSuccess, updateModuleByIdFailure, getModuleByIdSuccess, getModuleByIdFailure, getFormModuleListSuccess, getFormModuleListFailure, getFormListFailure, getFormListSuccess, createFormsListSuccess, createFormsListFailure, getManageModulesSuccess, getManageModulesFailure,
    createManageModuleSuccess,
    createManageModuleFailure,
    updateManageModuleSuccess,
    updateManageModuleFailure,
    getAllFormModuleListSuccess,
    getAllFormModuleListFailure,
    getAllFormModuleTableDataSuccess,
    getAllFormModuleTableDataFailure
} from "../../../Slices/formSlice";

export function* getAllFormModuleTableDataHandler(actions) {
    try {
        const response = yield call(getAllFormModuleTableData, actions?.payload);
        yield put(getAllFormModuleTableDataSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getAllFormModuleTableDataFailure(errResponse));
    }
}

export function* getAllFormModule(actions) {
    try {
        const response = yield call(getAllFormModuleData, actions?.payload);
        yield put(getAllFormModuleSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getAllFormModuleFailure(errResponse));
    }
}

export function* getFormsList(actions) {
    try {
        const response = yield call(getForms, actions?.payload);
        yield put(getFormListSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getFormListFailure(errResponse));
    }
}

export function* getAllFormModuleListHandler(actions) {
    try {
        let response = yield call(getAllFormModuleList, actions?.payload);
        yield put(getAllFormModuleListSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getAllFormModuleListFailure(errResponse))
    }
}

export function* getFormModuleListHandler(actions) {
    try {
        let response = yield call(getFormModuleList, actions?.payload);
        yield put(getFormModuleListSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getFormModuleListFailure(errResponse))
    }
}

export function* getModuleByIdLookUpHandler(actions) {
    try {
        let response = yield call(getModuleByIdLookUp, actions?.payload);
        yield put(getModuleByIdLookUpSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getModuleByIdLookUpFailure(errResponse))
    }
}

export function* getModuleByIdHandler(actions) {
    try {
        let response = yield call(getModuleById, actions?.payload);
        yield put(getModuleByIdSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getModuleByIdFailure(errResponse))
    }
}

export function* updateModuleByIdHandler(actions) {
    try {
        console.log(actions)
        let response = yield call(updateModuleById, actions?.payload);
        yield put(updateModuleByIdSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(updateModuleByIdFailure(errResponse))
    }
}

export function* createFormsHandler(actions) {
    try {
        let response = yield call(createModule, actions?.payload);
        yield put(createFormsListSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(createFormsListFailure(errResponse))
    }
}

export function* removeModuleModuleHandler(actions) {
    try {
        let response = yield call(removeModuleById, actions?.payload);
        yield put(removeModuleByIdSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(removeModuleByIdFailure(errResponse))
    }
}

export function* getManageModulesHandler(actions) {
    try {
        let response = yield call(getManageModules, actions?.payload);
        yield put(getManageModulesSuccess(response.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message || "An error occurred.";
        yield put(getManageModulesFailure(errResponse));
    }
}


export function* createManageModuleHandler(actions) {
    try {
        let response = yield call(createManageModule, actions?.payload);
        yield put(createManageModuleSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(createManageModuleFailure(errResponse));
    }
}


export function* updateManageModuleHandler(actions) {
    try {
        let response = yield call(updateManageModule, actions?.payload);
        yield put(updateManageModuleSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(updateManageModuleFailure(errResponse));
    }
}